/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/schedules'] || initialState;

export const selectSchedule = createSelector([selectDomain], (ScheduleListState) => ScheduleListState.schedules);
export const selectScheduleStateLoader = createSelector([selectDomain], (ScheduleListState) => ScheduleListState.loading);
export const selectSessionUrl = createSelector([selectDomain], (ScheduleListState) => ScheduleListState.sessionUrl);
